import { useEffect } from 'react';
/**
 * Hook that scrolls the viewport to center focused elements when they would be off-screen,
 * but only when focus is changed via keyboard navigation or screen reader.
 * This prevents unwanted scrolling from mouse clicks.
 */
export var useFocusScroll = function () {
    useEffect(function () {
        var isKeyboardNavigation = false;
        var handleKeyDown = function (event) {
            // Check for Tab key and common screen reader navigation keys
            if (event.key === 'Tab' ||
                event.key === 'ArrowDown' ||
                event.key === 'ArrowUp' ||
                event.key === 'ArrowLeft' ||
                event.key === 'ArrowRight' ||
                event.key === 'Enter' ||
                event.key === ' ') {
                isKeyboardNavigation = true;
            }
        };
        var handleFocus = function (event) {
            if (!isKeyboardNavigation)
                return;
            var target = event.target;
            var rect = target.getBoundingClientRect();
            var windowHeight = window.innerHeight;
            // Check if element is above or below the viewport
            var isAboveViewport = rect.top < 0;
            var isBelowViewport = rect.bottom > windowHeight;
            // Only scroll if element is not fully visible
            if (isAboveViewport || isBelowViewport) {
                // Small delay to ensure smooth transition
                setTimeout(function () {
                    var scrollTop = window.scrollY + rect.top - (windowHeight / 2) + 100;
                    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
                    window.scrollTo({
                        top: scrollTop,
                        behavior: prefersReducedMotion ? "auto" : "smooth",
                    });
                }, 50);
            }
            isKeyboardNavigation = false;
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('focus', handleFocus, true);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('focus', handleFocus, true);
        };
    }, []);
};
